import type { IconData } from '@stacksjs/iconify-core'

export const input: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M472 96H40a24.03 24.03 0 0 0-24 24v80h32v-72h416v256H48v-72H16v80a24.03 24.03 0 0 0 24 24h432a24.03 24.03 0 0 0 24-24V120a24.03 24.03 0 0 0-24-24\"/><path fill=\"currentColor\" d=\"m212.687 323.078l22.626 22.627l90.511-90.509l-90.511-90.51l-22.626 22.628l51.881 51.882H16v31.999h248.569z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default input
